/* eslint-disable react/no-unescaped-entities */
import { Grid } from '@material-ui/core';
import React from 'react';
import BoxWithTitle from '../Common/BoxWithTitle/BoxWithTitle';
import SimpleForm from '../Common/SimpleForm/SimpleForm';
import { LandingBoxStyle } from './LandingBox.style';

const LandingBox = (props: { title: string; children?: JSX.Element | JSX.Element[] }): JSX.Element => {
    const classes = LandingBoxStyle();

    return (
        <Grid container direction="column" className={classes.root}>
            <Grid item>
                <BoxWithTitle title={props.title}>
                    <SimpleForm spacing={1} style={{ borderBottom: 'none' }}>
                        {props.children}
                    </SimpleForm>
                </BoxWithTitle>
            </Grid>
        </Grid>
    );
};

export default LandingBox;
